/**
 * CVO Settings View
 * Dedicated route component for CVO settings management
 */

import React from 'react';
import { SettingsView } from './index';

const CVOSettingsView = () => {
  return <SettingsView />;
};

export default CVOSettingsView;
